/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ConfirmedActionItemDto } from "./ConfirmedActionItemDto";
import {
  ConfirmedActionItemDtoFromJSON,
  ConfirmedActionItemDtoFromJSONTyped,
  ConfirmedActionItemDtoToJSON,
  ConfirmedActionItemDtoToJSONTyped,
} from "./ConfirmedActionItemDto";

/**
 *
 * @export
 * @interface LogCompanyMeetingRequest
 */
export interface LogCompanyMeetingRequest {
  /**
   *
   * @type {string}
   * @memberof LogCompanyMeetingRequest
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof LogCompanyMeetingRequest
   */
  jamieMeetingId: string;
  /**
   *
   * @type {Array<ConfirmedActionItemDto>}
   * @memberof LogCompanyMeetingRequest
   */
  actionItems: Array<ConfirmedActionItemDto>;
}

/**
 * Check if a given object implements the LogCompanyMeetingRequest interface.
 */
export function instanceOfLogCompanyMeetingRequest(
  value: object,
): value is LogCompanyMeetingRequest {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("jamieMeetingId" in value) || value["jamieMeetingId"] === undefined)
    return false;
  if (!("actionItems" in value) || value["actionItems"] === undefined)
    return false;
  return true;
}

export function LogCompanyMeetingRequestFromJSON(
  json: any,
): LogCompanyMeetingRequest {
  return LogCompanyMeetingRequestFromJSONTyped(json, false);
}

export function LogCompanyMeetingRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LogCompanyMeetingRequest {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    jamieMeetingId: json["jamieMeetingId"],
    actionItems: (json["actionItems"] as Array<any>).map(
      ConfirmedActionItemDtoFromJSON,
    ),
  };
}

export function LogCompanyMeetingRequestToJSON(
  json: any,
): LogCompanyMeetingRequest {
  return LogCompanyMeetingRequestToJSONTyped(json, false);
}

export function LogCompanyMeetingRequestToJSONTyped(
  value?: LogCompanyMeetingRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    jamieMeetingId: value["jamieMeetingId"],
    actionItems: (value["actionItems"] as Array<any>).map(
      ConfirmedActionItemDtoToJSON,
    ),
  };
}
